import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { setSEO } from '../lib/seo';

const C = { navy:'#001f3a', navyMid:'#0b3558', navyDark:'#0d1f30', orange:'#f07820', orangeDk:'#9a4600', light:'#f8f9ff', lightMid:'#eef4ff', white:'#ffffff' };
const LOGO_W = `${process.env.PUBLIC_URL}/LogoBlanco.png`;
const LOGO_D = `${process.env.PUBLIC_URL}/LogoOficial.png`;
const CPLS   = `${process.env.PUBLIC_URL}/CPLS.png`; // Sello Certiprof - Certified Partner for Learning Solutions

const S = (extra='') => `
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@700;800;900&family=Inter:wght@400;500;600&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',sans-serif;background:${C.light}}
  .d{font-family:'Manrope',sans-serif} a{text-decoration:none}
  .bo{background:linear-gradient(135deg,${C.orange},${C.orangeDk});color:white;border:none;cursor:pointer;font-family:'Inter',sans-serif;font-weight:700;transition:opacity .18s;display:inline-flex;align-items:center;gap:8px}
  .bo:hover{opacity:.9}
  .ch{transition:box-shadow .2s,transform .2s} .ch:hover{box-shadow:0 16px 40px rgba(0,31,58,.1);transform:translateY(-2px)}
  .field{width:100%;padding:11px 14px;border-radius:8px;border:1.5px solid rgba(0,31,58,.12);font-size:14px;outline:none;color:${C.navy};background:white;font-family:'Inter',sans-serif}
  .field:focus{border-color:${C.orange}}
  ${extra}
`;

const Nav = ({ dark } = {}) => (
  <nav style={{ background:C.navyDark, padding:'0 40px', height:'56px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
    <a href="/"><img src={LOGO_W} alt="HireMeUp" style={{ height:'100px', objectFit:'contain' }} /></a>
    <div style={{ display:'flex', gap:'20px', alignItems:'center' }}>
      <a href="/" style={{ fontSize:'13px', color:'rgba(255,255,255,.5)', fontFamily:'Inter,sans-serif' }}>Inicio</a>
      <a href="https://app.hiremeupglobal.com" style={{ display:'inline-flex', alignItems:'center', gap:'6px', padding:'7px 14px', borderRadius:'8px', background:`linear-gradient(135deg,${C.orange},${C.orangeDk})`, color:'white', fontSize:'13px', fontWeight:700 }}>Ir a la app</a>
    </div>
  </nav>
);

const Footer = () => (
  <footer style={{ background:C.navyDark, padding:'24px 40px', borderTop:'1px solid rgba(255,255,255,.06)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'12px' }}>
    <img src={LOGO_W} alt="HireMeUp" style={{ height:'28px', objectFit:'contain' }} />
    <div style={{ display:'flex', gap:'20px' }}>
      {[['Servicios','/'],['Academy','/academy'],['Nosotros','/nosotros'],['Contacto','/contacto'],['Deja tu testimonio','/feedback']].map(([l,h]) => (
        <a key={l} href={h} style={{ fontSize:'12px', color:'rgba(255,255,255,.3)', fontFamily:'Inter,sans-serif' }}>{l}</a>
      ))}
    </div>
    <p style={{ fontSize:'12px', color:'rgba(255,255,255,.2)' }}>© 2026 HireMeUp Global</p>
  </footer>
);


// ─── HIREMDEEP ────────────────────────────────────────────────────────────────
export function WebHireMeDeep() {
  useEffect(() => {
    setSEO({
      title: 'HireMeDeep | Mentoría Estratégica 1:1 para tu Carrera Remota - HireMeUp',
      description: 'Mentoría estratégica intensiva 1:1 de mínimo 4 sesiones. Desbloquea lo que te detiene y redefine tu carrera con claridad. Exclusivo para profesionales de LATAM.',
      canonical: 'https://hiremeupglobal.com/hiremedeep',
    });
  }, []);
  return (
    <>
      <style>{S()}</style>
      <Nav />
      <section style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'80px 40px', textAlign:'center' }}>
        <div style={{ maxWidth:'700px', margin:'0 auto' }}>
          <span style={{ display:'inline-block', fontSize:'11px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:C.orange, background:'rgba(240,120,32,.12)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'5px 14px', marginBottom:'20px' }}>MENTORÍA ESTRATÉGICA</span>
          <h1 className="d" style={{ fontSize:'clamp(2rem,5vw,3.2rem)', fontWeight:900, letterSpacing:'-.03em', color:'white', lineHeight:1.1, marginBottom:'16px' }}>Desbloquea lo que hoy<br /><span style={{ color:C.orange }}>te detiene.</span></h1>
          <p style={{ fontSize:'16px', lineHeight:1.7, color:'rgba(255,255,255,.6)', marginBottom:'32px' }}>Mentoría 1:1 para avanzar con claridad, tomar decisiones clave y recuperar tu impulso profesional.</p>
          <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Ya7flpt940CvTAtl6yIdtQ03hG4FMdr9fnS6dWMdQ7n5WjNOq4zzaGwMztIKJd22GX0uCjGrH" target="_blank" rel="noopener noreferrer" className="bo" style={{ padding:'14px 28px', borderRadius:'10px', fontSize:'15px', margin:'0 auto' }}>Quiero avanzar con HireMeDeep</a>
        </div>
      </section>
      <section style={{ padding:'64px 40px', background:C.light }}>
        <div style={{ maxWidth:'900px', margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(340px,1fr))', gap:'32px' }}>
          <div>
            <h2 className="d" style={{ fontSize:'22px', fontWeight:800, color:C.navy, marginBottom:'20px' }}>¿Qué incluye?</h2>
            {['Diagnóstico profundo de bloqueos internos y externos','Estrategia personalizada para decisiones clave','Rediseño realista de tus objetivos profesionales','Mínimo 4 sesiones 1:1 de 60 minutos con foco en resultados','Acompañamiento estratégico hasta que avances con claridad'].map((f,i) => (
              <div key={i} style={{ display:'flex', gap:'12px', marginBottom:'12px' }}>
                <div style={{ width:'20px', height:'20px', borderRadius:'50%', background:`${C.orange}15`, border:`1px solid ${C.orange}30`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:'2px' }}>
                  <span style={{ color:C.orange, fontSize:'11px' }}>✓</span>
                </div>
                <p style={{ fontSize:'14px', color:'rgba(0,31,58,.7)', lineHeight:1.5 }}>{f}</p>
              </div>
            ))}
          </div>
          <div>
            <h2 className="d" style={{ fontSize:'22px', fontWeight:800, color:C.navy, marginBottom:'20px' }}>¿Para quién es?</h2>
            {['Estás en transición y quieres claridad sobre tu próximo paso','Te sientes estancado o invisible en tu carrera','Has perdido motivación o seguridad profesional','Quieres apoyo estratégico para superar bloqueos reales'].map((f,i) => (
              <div key={i} style={{ display:'flex', gap:'12px', marginBottom:'12px' }}>
                <div style={{ width:'20px', height:'20px', borderRadius:'50%', background:`${C.navyMid}10`, border:`1px solid ${C.navyMid}20`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:'2px' }}>
                  <span style={{ color:C.navyMid, fontSize:'11px' }}>✓</span>
                </div>
                <p style={{ fontSize:'14px', color:'rgba(0,31,58,.7)', lineHeight:1.5 }}>{f}</p>
              </div>
            ))}
          </div>
        </div>
        <div style={{ maxWidth:'900px', margin:'40px auto 0', borderRadius:'16px', padding:'32px 40px', background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, textAlign:'center' }}>
          <p className="d" style={{ fontSize:'18px', fontWeight:800, color:'white', marginBottom:'8px' }}>HireMeDeep no es coaching genérico.</p>
          <p style={{ fontSize:'15px', color:'rgba(255,255,255,.55)', marginBottom:'24px' }}>Es mentoría estratégica intensiva, única en LATAM, creada para desbloquear lo que hoy te detiene y rediseñar tu rumbo profesional.</p>
          <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Ya7flpt940CvTAtl6yIdtQ03hG4FMdr9fnS6dWMdQ7n5WjNOq4zzaGwMztIKJd22GX0uCjGrH" target="_blank" rel="noopener noreferrer" className="bo" style={{ padding:'13px 28px', borderRadius:'10px', fontSize:'14px', margin:'0 auto' }}>Reservar sesión</a>
        </div>
      </section>
      <Footer />
    </>
  );
}

// ─── HIREMEBRIDGE ─────────────────────────────────────────────────────────────
export function WebHireMeBridge() {
  useEffect(() => {
    setSEO({
      title: 'HireMeBridge | Sesión Diagnóstico 1:1 de Empleabilidad - HireMeUp',
      description: 'Sesión diagnóstico 1:1 de 60 minutos para analizar tu situación profesional, romper bloqueos y trazar un plan de acción concreto desde el primer día.',
      canonical: 'https://hiremeupglobal.com/hiremebridge',
    });
  }, []);
  return (
    <>
      <style>{S()}</style>
      <Nav />
      <section style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'80px 40px', textAlign:'center' }}>
        <div style={{ maxWidth:'700px', margin:'0 auto' }}>
          <span style={{ display:'inline-block', fontSize:'11px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:C.orange, background:'rgba(240,120,32,.12)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'5px 14px', marginBottom:'20px' }}>SESIÓN DIAGNÓSTICO 1:1</span>
          <h1 className="d" style={{ fontSize:'clamp(2rem,5vw,3.2rem)', fontWeight:900, letterSpacing:'-.03em', color:'white', lineHeight:1.1, marginBottom:'16px' }}>Encuentra claridad.<br /><span style={{ color:C.orange }}>Traza tu rumbo.</span></h1>
          <p style={{ fontSize:'16px', lineHeight:1.7, color:'rgba(255,255,255,.6)', marginBottom:'32px' }}>En una sesión 1:1 analizamos tu situación, desbloqueamos lo que te frena y diseñamos un plan de acción realista desde el primer día.</p>
          <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Ya7flpt940CvTAtl6yIdtQ03hG4FMdr9fnS6dWMdQ7n5WjNOq4zzaGwMztIKJd22GX0uCjGrH" target="_blank" rel="noopener noreferrer" className="bo" style={{ padding:'14px 28px', borderRadius:'10px', fontSize:'15px', margin:'0 auto' }}>Definir mi próximo paso</a>
        </div>
      </section>
      <section style={{ padding:'64px 40px', background:C.light }}>
        <div style={{ maxWidth:'900px', margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:'20px', marginBottom:'40px' }}>
          {[
            { title:'Lo que obtienes', items:['Claridad sobre tu posicionamiento profesional','Plan de acción aplicable desde el primer día','Diagnóstico de bloqueos y oportunidades','Sesión 1:1 de 60 min via Google Meet'] },
            { title:'¿Para quién es?', items:['Te sientes estancado o sin rumbo','Has aplicado sin obtener resultados','Quieres claridad antes de decisiones importantes','Buscas un diagnóstico profesional honesto'] },
          ].map(b => (
            <div key={b.title} style={{ borderRadius:'16px', padding:'28px', background:C.white, boxShadow:'0 4px 24px rgba(0,31,58,.06)' }}>
              <h3 className="d" style={{ fontSize:'17px', fontWeight:800, color:C.navy, marginBottom:'16px' }}>{b.title}</h3>
              {b.items.map((f,i) => (
                <div key={i} style={{ display:'flex', gap:'10px', marginBottom:'10px' }}>
                  <span style={{ color:C.orange, flexShrink:0, marginTop:'1px' }}>✓</span>
                  <p style={{ fontSize:'14px', color:'rgba(0,31,58,.7)', lineHeight:1.5 }}>{f}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div style={{ maxWidth:'900px', margin:'0 auto', borderRadius:'16px', padding:'28px 40px', background:C.lightMid, border:'1px solid rgba(0,31,58,.06)', textAlign:'center' }}>
          <p className="d" style={{ fontSize:'17px', fontWeight:800, color:C.navy, marginBottom:'8px' }}>No es una charla motivacional.</p>
          <p style={{ fontSize:'15px', color:'rgba(0,31,58,.55)', marginBottom:'24px' }}>Es una sesión práctica con claridad y resultados desde el primer día. Tu dirección profesional no se descubre, se construye.</p>
          <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Ya7flpt940CvTAtl6yIdtQ03hG4FMdr9fnS6dWMdQ7n5WjNOq4zzaGwMztIKJd22GX0uCjGrH" target="_blank" rel="noopener noreferrer" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px' }}>Reservar sesión</a>
        </div>
      </section>
      <Footer />
    </>
  );
}

// ─── ACADEMY ──────────────────────────────────────────────────────────────────

const CERTS = [
  {
    title: 'Remote Operations & AI Support Professional',
    code: 'ROASP',
    slug: 'remote-operations-ai-support',
    desc: 'Competencias de operación remota con IA altamente demandadas por equipos globales, para preparar talento listo para trabajar desde el día 1.',
    duration: '24 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/beAoHZ6STbGvgP796',
    brochure: 'https://drive.google.com/file/d/1f-joGFpmWRCiT02dRrqbGSUNIqtx7hQX/view?usp=sharing',
    color: '#f07820',
    detail: {
      tagline: 'Competencias remotas con IA, listas para equipos globales.',
      about: 'Certifica un conjunto de competencias profesionales altamente demandadas por empresas remotas y equipos globales. Prepara al profesional para aportar valor real desde el día 1, sin importar el título del puesto.',
      facts: ['24 sesiones en vivo', '35 horas de formación', '+150 países de validez', 'Español · inglés funcional B1'],
      forWhom: ['Profesionales que migran al mercado remoto global', 'Quienes operan con criterio, autonomía y uso estratégico de IA', 'Personas que buscan mejores oportunidades de ingreso', 'Profesionales que se diferencian en entornos internacionales'],
      objectives: ['Criterio de negocio: entender prioridades y trabajar con impacto en resultados', 'Ejecución confiable: autonomía, menos fricción operativa y más productividad', 'Comunicación profesional en inglés funcional B1 en entornos distribuidos', 'Uso estratégico de IA generativa para más velocidad, precisión y calidad'],
      roles: ['Apoyo operativo avanzado en entornos remotos', 'Coordinación y ejecución con uso de IA', 'Operaciones para startups y equipos distribuidos', 'Soporte estratégico a líderes y founders'],
      requisitos: ['Inglés funcional B1 aplicado a comunicación remota', 'Aprobación mínima del 70% para acceder a la certificación'],
    },
  },
  {
    title: 'Agile Coach Professional',
    code: 'ACPC',
    slug: 'agile-coach',
    desc: 'Forma agile coaches capaces de catalizar el cambio: marcos ágiles, principios Lean y herramientas de facilitación y mentoring para equipos de alto rendimiento.',
    duration: '6 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/Kyz6Mf5aTmHJF4Da8',
    brochure: 'https://drive.google.com/file/d/1ZtgX_tOCZHzUwEFMxZeT2cGfhBNeqUHH/view?usp=sharing',
    color: '#2563eb',
    detail: {
      tagline: 'Aplica la transformación ágil en personas y organizaciones.',
      about: 'Formación práctica en agile coaching basada en el ADN del Agile Coach: dominio de marcos ágiles, principios Lean y herramientas de facilitación, mentoring y enseñanza para catalizar el cambio.',
      facts: ['6 sesiones de 2 horas', '12 horas totales', 'Online · En vivo', 'Enfoque práctico'],
      forWhom: ['Líderes de proyectos de software', 'Profesionales del ecosistema TI', 'Personas que amplían sus habilidades blandas y de gestión ágil'],
      objectives: ['Comprender el rol y las competencias fundamentales del Agile Coach', 'Actuar como maestro y aprendiz mediante la mejora continua', 'Dominar principios y valores ágiles más allá de la teoría', 'Ofrecer el conocimiento adecuado en el momento justo', 'Guiar procesos de cambio del estado actual a un futuro mejor'],
      modules: ['Introducción y Mentalidad: el rol del Agile Coach, el camino y las competencias', 'Liderazgo Lean-Agile: manifiesto, principios y entornos V.U.C.A. & BANI', 'El proceso de Coaching: etapas, métodos, herramientas y niveles', 'Facilitación y Enseñanza: docencia, mentoring y manejo de equipos', 'Herramientas Habilitadoras: preguntas poderosas, Kafe Model y Learning Canvas', 'Marcos y Agilidad a Escala: Scrum, Kanban, DevOps, SAFe y Design Thinking'],
    },
  },
  {
    title: 'Artificial Intelligence Professional',
    code: 'CAIPC',
    slug: 'artificial-intelligence-professional',
    desc: 'Forma a tu equipo en Machine Learning aplicado: algoritmos, Python y Scikit-learn con proyectos guiados sobre problemas reales de negocio.',
    duration: '6 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/ANGHHAuymnDteVoe8',
    brochure: 'https://drive.google.com/file/d/11Oj-7CkcWslETcqW76eSXuewby-cYxM3/view?usp=sharing',
    color: '#7c3aed',
    detail: {
      tagline: 'Potencia la toma de decisiones con Inteligencia Artificial.',
      about: 'Formación técnica e intensiva en Machine Learning aplicado: algoritmos supervisados y no supervisados, Python y Scikit-learn, con proyectos guiados sobre problemas reales de negocio. 80% práctico.',
      facts: ['6 sesiones de 2 horas', '12 horas totales', 'Online · En vivo', '80% práctico'],
      forWhom: ['Ingenieros y analistas', 'Directores de marketing', 'Científicos de datos', 'Profesionales interesados en minería de datos y aprendizaje automático'],
      objectives: ['Comprender los fundamentos de la IA y el Machine Learning', 'Aplicar métodos de aprendizaje supervisado y no supervisado', 'Usar el análisis de datos para decisiones estratégicas', 'Comprender los límites de los algoritmos y su alcance ético', 'Dominar Python y los conocimientos matemáticos esenciales para IA', 'Evaluar el rendimiento y la calidad de las predicciones'],
      modules: ['Fundamentos de ML: IA, modelos supervisados, no supervisados y por refuerzo', 'Algoritmo K-Nearest Neighbors: datos, distancia euclidiana y predicción', 'Evaluación de modelos: métricas de error (MSE, RMSE) y Scikit-learn', 'Matemáticas para IA: cálculo, álgebra lineal y sistemas lineales', 'Regresión y clasificación: descenso de gradientes y regresión logística', 'Árboles de decisión y clustering: K-means y proyectos de predicción reales'],
    },
  },
  {
    title: 'Certified AI Project Management Specialist',
    code: 'CAIPMG',
    slug: 'ai-project-management',
    desc: 'Capacita a tus líderes para gestionar proyectos tecnológicos con IA integrada: planificación, riesgos, finanzas y cierre, con aplicación inmediata.',
    duration: '6 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/wTxdwFT6FBRmG6z76',
    brochure: 'https://drive.google.com/file/d/1qGB_RVf7EOd7Wl_tN8FgPtSlJPSFOXbH/view?usp=sharing',
    color: '#0369a1',
    detail: {
      tagline: 'Gestiona proyectos reales con Inteligencia Artificial.',
      about: 'Aprende a gestionar proyectos tecnológicos con IA integrada: planificación, recursos, riesgos, finanzas y cierre, con aplicación inmediata en proyectos reales. 80% práctico.',
      facts: ['6 sesiones de 2 horas', '12 horas totales', 'Online · En vivo', '80% práctico'],
      forWhom: ['Project Managers', 'Coordinadores y líderes', 'Profesionales que gestionan equipos', 'Emprendedores y consultores', 'Quienes buscan potenciar su perfil con IA'],
      objectives: ['Comprender la mentalidad y el rol del AI Project Manager', 'Planificar proyectos y recursos de forma eficiente', 'Gestionar comunicación, stakeholders y riesgos', 'Entender fundamentos financieros aplicados a proyectos', 'Realizar seguimiento, control y cierre de proyectos', 'Aplicar herramientas de IA en todo el ciclo del proyecto'],
      modules: ['Mentalidad del Project Manager: rol, habilidades y enfoque moderno con IA', 'Planificación y recursos: alcance, tiempo y planificación inteligente', 'Comunicación y riesgos: gestión de stakeholders y mitigación de riesgos', 'Finanzas para proyectos: presupuestos, costos y análisis financiero', 'Seguimiento, control y cierre: KPIs, monitoreo y control del proyecto', 'IA aplicada a la gestión: herramientas que automatizan, analizan y mejoran decisiones'],
    },
  },
  {
    title: 'Certified AI Product Manager Specialist',
    code: 'CAIPM',
    slug: 'ai-product-manager',
    desc: 'Capacita a tus Product Owners y PMs para integrar IA en todo el ciclo de vida del producto: discovery, roadmap, backlog y gobernanza.',
    duration: '8 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/fcmH3mPk7BYQ1Ljf9',
    brochure: 'https://drive.google.com/file/d/12gmIkjTJJBRrAGqNUMI6-fULwt6GIs8H/view?usp=sharing',
    color: '#0f766e',
    detail: {
      tagline: 'Integra la IA en cada etapa del ciclo de vida del producto.',
      about: 'Un programa intensivo para integrar la Inteligencia Artificial en cada etapa del ciclo de vida del producto y potenciar el rol estratégico del Product Manager: desde el discovery y el roadmap hasta la gobernanza y la analítica predictiva. Al finalizar, cada participante desarrolla un AI-Driven Product Playbook aplicable a su proyecto actual.',
      facts: ['8 sesiones de 2 horas', '16 horas totales', 'Online · En vivo', '100% práctico'],
      forWhom: ['Product Owners y Product Managers de todos los niveles', 'Líderes de producto que implementan marcos de trabajo aumentados con IA', 'Profesionales en transición que buscan una ventaja competitiva diferencial'],
      objectives: ['Prompt Engineering avanzado para todas las fases del ciclo de vida del producto', 'Discovery y roadmapping con IA para maximizar el valor de negocio', 'Modelado predictivo para reducir la incertidumbre estratégica', 'Gobernanza y ética: seguridad de datos, privacidad y cumplimiento', 'Agilidad aumentada: refinamiento, estimación y flujo del equipo con IA'],
      modules: ['Fundamentos y eficiencia operativa: Prompt Engineering, colaboración responsable y gestión táctica del backlog', 'Estrategia y descubrimiento de producto: deep discovery, segmentación avanzada y roadmapping dinámico', 'Gobernanza y estrategia predictiva: simulación y analítica predictiva, ética y liderazgo de equipos aumentados con IA'],
      materials: 'Toolbox: repositorio completo de Prompt Frameworks, guía de implementación "AI Governance for Product Leaders" y acceso a la comunidad exclusiva de especialistas certificados.',
    },
  },
];

const TESTER_TRACK = [
  {
    nivel: 'Junior',
    badge: 'Nivel 1',
    title: 'AI Tester Junior Specialist',
    code: 'AITJ',
    slug: 'ai-tester-junior',
    desc: 'Integra IA generativa en el proceso de pruebas, pasando de ejecutar casos manuales a diseñar estrategias de testing asistidas por IA.',
    duration: '4 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/5FaEmLZmwwYzYXs16',
    brochure: 'https://drive.google.com/file/d/11mFZuthaNB3RmqSaD3BqWgzpOgxqlbyi/view?usp=sharing',
    color: '#2563eb',
    bg: 'rgba(37,99,235,.07)',
    detail: {
      tagline: 'Integra IA generativa en tu proceso de pruebas.',
      about: 'Especialización que transforma al tester convencional en un profesional capaz de integrar IA generativa en el ciclo de pruebas mediante ingeniería de prompts, mejorando eficiencia, precisión y análisis técnico. 80% práctico.',
      facts: ['4 sesiones de 2 horas', '8 horas totales', 'Online · En vivo', '80% práctico'],
      forWhom: ['Testers manuales que evolucionan a un rol más técnico', 'Estudiantes de carreras tecnológicas interesados en QA', 'Profesionales de QA que integran GenAI en su flujo diario'],
      objectives: ['Dominio de arquitectura de prompts (CTF, System Role)', 'Generación técnica de datos (JSON, XML, CSV) con few-shot prompting', 'Análisis técnico y causa raíz interpretando logs con IA', 'Documentación profesional de defectos de alto impacto', 'Pensamiento crítico: detectar alucinaciones, sesgos y validación cruzada'],
      modules: ['Fundamentos y Ética: arquitectura de LLM, limitaciones y gobernanza de datos', 'Ingeniería de Prompts para Ejecución: CTF, Few-Shot QA Pattern y refactorización', 'Generación de Datos y Análisis Técnico: datasets complejos y Log Interpreter Pattern', 'Documentación e Integración: Bug Advocacy Framework y proyecto integrador en e-commerce'],
      materials: 'Toolbox de Prompt Frameworks y Guía Maestra de prompts para Testers Junior (PDF).',
    },
  },
  {
    nivel: 'Semi Senior',
    badge: 'Nivel 2',
    title: 'AI Tester Semi Senior Specialist',
    code: 'AITS',
    slug: 'ai-tester-semi-senior',
    desc: 'Trasciende la ejecución manual hacia el diseño estratégico de pruebas: automatización profesional (POM) y security testing bajo estándar OWASP.',
    duration: '4 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/mLHGZnnAL4nB5X136',
    brochure: 'https://drive.google.com/file/d/1LxpMa9I1zaeyLihgjE7DGif57ZkD_ED9/view?usp=sharing',
    color: '#7c3aed',
    bg: 'rgba(124,58,237,.07)',
    detail: {
      tagline: 'Diseño estratégico de pruebas con IA y security testing.',
      about: 'Para profesionales de QA que buscan trascender la ejecución manual: diseño de planes complejos, automatización profesional con Page Object Model y security testing bajo estándar OWASP, con gobernanza y ética empresarial. 80% práctico.',
      facts: ['4 sesiones de 2 horas', '8 horas totales', 'Online · En vivo', '80% práctico'],
      forWhom: ['Testers junior que dan el salto a semi senior', 'Testers con experiencia que se especializan en automatización', 'Automation engineers que optimizan tiempos de desarrollo', 'Analistas de QA responsables de estrategia y diseño', 'Interesados en seguridad informática aplicada al testing'],
      objectives: ['Ingeniería de prompts avanzada (Chain-of-Thought, Role Prompting)', 'Automatización estratégica con Page Object Model (POM)', 'Security testing asistido por IA bajo estándar OWASP', 'Gobernanza y ética: seguridad de datos y anonimización', 'Descomposición técnica de requerimientos en test suites mantenibles'],
      modules: ['Ingeniería de Prompts Avanzada y Razonamiento Lógico (CoT, Negative Prompting, Expert Personas)', 'Automatización de Pruebas Asistida por IA: Page Object Model y refactorización', 'Security Testing y Análisis de Vulnerabilidades: OWASP, payloads de inyección/XSS', 'Gobernanza, Ética y Responsabilidad Corporativa: Data Masking y auditoría de IA'],
      materials: 'Guía avanzada de Prompt Engineering para QA (PDF) y checklists de cumplimiento y gobernanza.',
    },
  },
  {
    nivel: 'Senior',
    badge: 'Nivel 3',
    title: 'AI Tester Senior Specialist',
    code: 'AITR',
    slug: 'ai-tester-senior',
    desc: 'Lidera la adopción estratégica de IA en calidad a nivel organizacional: gobernanza, compliance y ROI en ecosistemas DevSecOps.',
    duration: '4 sesiones',
    format: 'Online · En vivo',
    registro: 'https://forms.gle/tjFgfZj6tZFwXuNZ7',
    brochure: 'https://drive.google.com/file/d/1Z3A6_LKUksqsKX4-_2XFRUV2ICmTfWIl/view?usp=sharing',
    color: '#f07820',
    bg: 'rgba(240,120,32,.07)',
    detail: {
      tagline: 'Liderazgo estratégico de la calidad con IA a nivel organizacional.',
      about: 'Para líderes y gerentes de calidad que asumen la responsabilidad estratégica de la adopción de IA en su organización: diseño de roadmaps de transformación, optimización de procesos con analítica predictiva e integración de IA en ecosistemas DevSecOps, con énfasis en cumplimiento normativo (GDPR/SOC2) y retorno de inversión (ROI).',
      facts: ['4 sesiones de 2 horas', '8 horas totales', 'Online · En vivo', 'Enfoque estratégico'],
      forWhom: ['QA Managers y Test Leads responsables de la estrategia de calidad', 'Arquitectos de testing que diseñan infraestructuras de validación a gran escala', 'Directores de Tecnología (CTO) o de Calidad en transformación digital', 'Consultores senior de QA que asesoran en la adopción de IA'],
      objectives: ['Estrategia organizacional: diseñar y liderar un roadmap de adopción de IA en QA', 'Analítica predictiva: detección temprana de riesgos y optimización de esfuerzos', 'Gobernanza y compliance: cumplimiento de GDPR, SOC2 e ISO en el uso de LLMs', 'Business case y ROI: demostrar el valor financiero de la IA aplicada al testing', 'Liderazgo de cambio: mentorizar equipos hacia una mentalidad QA-AI First'],
      modules: ['Estrategia y gobernanza de IA: modelos de madurez, roadmaps, arquitecturas RAG para bases de conocimiento privadas y seguridad de datos corporativos', 'Optimización y analítica predictiva: process mining asistido por IA, predicción de defectos y dashboards de métricas avanzadas', 'Compliance y seguridad en DevSecOps: auditoría bajo estándares internacionales, gestión de sesgos y automatización de controles', 'Liderazgo, coaching y ROI: gestión del cambio cultural, business cases para el C-Level y métricas de eficiencia operativa'],
      materials: 'Guía de cumplimiento normativo, checklists de seguridad empresarial, guía avanzada de Prompt Engineering para líderes y toolbox de frameworks.',
    },
  },
];

// Lookup por slug para las páginas de detalle
const ALL_COURSES = [...CERTS, ...TESTER_TRACK];
const COURSE_BY_SLUG = ALL_COURSES.reduce((acc, c) => { acc[c.slug] = c; return acc; }, {});

function CertCard({ cert }) {
  return (
    <a href={`/academy/${cert.slug}`} className="ch" style={{ borderRadius:'16px', background:C.white, boxShadow: cert.featured ? `0 0 0 2px ${cert.color}, 0 8px 32px rgba(0,31,58,.10)` : '0 4px 24px rgba(0,31,58,.06)', display:'flex', flexDirection:'column', overflow:'hidden', position:'relative', textDecoration:'none' }}>
      {/* Barra de color superior */}
      <div style={{ height:'4px', background:`linear-gradient(90deg,${cert.color},${cert.color}88)` }} />
      <div style={{ padding:'24px 24px 20px', flex:1, display:'flex', flexDirection:'column' }}>
        {/* Badge featured */}
        {cert.featured && (
          <div style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:`${cert.color}15`, border:`1px solid ${cert.color}40`, borderRadius:'20px', padding:'3px 10px', marginBottom:'12px', alignSelf:'flex-start' }}>
            <div style={{ width:'5px', height:'5px', borderRadius:'50%', background:cert.color }} />
            <span style={{ fontSize:'9px', fontWeight:700, color:cert.color, letterSpacing:'.08em', textTransform:'uppercase' }}>{cert.featuredLabel}</span>
          </div>
        )}
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'10px', gap:'10px' }}>
          <h3 className="d" style={{ fontSize:'14px', fontWeight:800, color:C.navy, lineHeight:1.3, flex:1 }}>{cert.title}</h3>
          <span style={{ fontSize:'10px', fontWeight:700, padding:'3px 9px', borderRadius:'20px', background:`${cert.color}12`, color:cert.color, whiteSpace:'nowrap', flexShrink:0, border:`1px solid ${cert.color}25` }}>{cert.code}</span>
        </div>
        {/* Chips duración + formato */}
        {(cert.duration || cert.format) && (
          <div style={{ display:'flex', gap:'6px', flexWrap:'wrap', marginBottom:'10px' }}>
            {cert.duration && (
              <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', fontSize:'10px', fontWeight:600, color:'rgba(0,31,58,.5)', background:'rgba(0,31,58,.05)', borderRadius:'6px', padding:'3px 8px' }}>
                🕐 {cert.duration}
              </span>
            )}
            {cert.format && (
              <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', fontSize:'10px', fontWeight:600, color:'rgba(0,31,58,.5)', background:'rgba(0,31,58,.05)', borderRadius:'6px', padding:'3px 8px' }}>
                💻 {cert.format}
              </span>
            )}
          </div>
        )}
        <p style={{ fontSize:'13px', lineHeight:1.65, color:'rgba(0,31,58,.55)', flex:1, marginBottom:'18px' }}>{cert.desc}</p>
        <span className="d" style={{ display:'inline-flex', alignItems:'center', gap:'6px', fontSize:'13px', fontWeight:800, color:cert.color }}>
          Ver programa →
        </span>
      </div>
    </a>
  );
}

function TesterTrackCard() {
  return (
    <div style={{ borderRadius:'16px', background:C.white, boxShadow:'0 4px 24px rgba(0,31,58,.06)', overflow:'hidden', gridColumn:'1 / -1' }}>
      {/* Header del track */}
      <div style={{ padding:'24px 28px 20px', background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px', flexWrap:'wrap' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
          <div style={{ display:'flex', gap:'6px' }}>
            {['#2563eb','#7c3aed','#f07820'].map((c,i) => (
              <div key={i} style={{ width:'10px', height:'10px', borderRadius:'50%', background:c }} />
            ))}
          </div>
          <div>
            <span style={{ fontSize:'10px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:C.orange }}>Track completo · 3 niveles</span>
            <h3 className="d" style={{ fontSize:'18px', fontWeight:800, color:'white', marginTop:'2px', lineHeight:1.1 }}>AI Tester Specialist</h3>
          </div>
        </div>
        <p style={{ fontSize:'13px', color:'rgba(255,255,255,.45)', maxWidth:'320px', lineHeight:1.5 }}>
          Un itinerario en 3 niveles para llevar a tu equipo de QA del testing manual al liderazgo de calidad con IA.
        </p>
      </div>
      {/* Cards de niveles siempre visibles */}
      <div style={{ padding:'20px 24px', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:'14px' }}>
        {TESTER_TRACK.map(t => (
          <a key={t.nivel} href={`/academy/${t.slug}`} className="ch" style={{ borderRadius:'12px', padding:'18px 20px', background:t.bg, border:`1.5px solid ${t.color}30`, display:'flex', flexDirection:'column', textDecoration:'none' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'8px' }}>
              <span style={{ fontSize:'10px', fontWeight:700, padding:'3px 9px', borderRadius:'20px', background:t.color, color:'white' }}>{t.badge}</span>
              <span className="d" style={{ fontSize:'12px', fontWeight:800, color:t.color }}>{t.nivel}</span>
            </div>
            <h4 className="d" style={{ fontSize:'13px', fontWeight:800, color:C.navy, marginBottom:'4px', lineHeight:1.3 }}>{t.title}</h4>
            {t.duration && (
              <span style={{ display:'inline-flex', alignItems:'center', fontSize:'10px', fontWeight:600, color:'rgba(0,31,58,.4)', background:'rgba(0,31,58,.05)', borderRadius:'6px', padding:'2px 7px', marginBottom:'8px', alignSelf:'flex-start' }}>
                🕐 {t.duration} · En vivo
              </span>
            )}
            <p style={{ fontSize:'12px', lineHeight:1.55, color:'rgba(0,31,58,.6)', marginBottom:'14px', flex:1 }}>{t.desc}</p>
            <span className="d" style={{ fontSize:'12px', fontWeight:800, color:t.color }}>Ver programa →</span>
          </a>
        ))}
      </div>
    </div>
  );
}

const PASOS = [
  { num:'01', title:'Cuéntanos tu objetivo', desc:'Hablas con un asesor sobre las necesidades, el nivel y el tamaño de tu equipo.' },
  { num:'02', title:'Diseñamos la cohorte', desc:'Armamos una cohorte cerrada con los programas y el calendario que mejor se adaptan a tu organización.' },
  { num:'03', title:'Formación en vivo', desc:'Tu equipo se forma en sesiones en vivo con instructor, 100% en español y con enfoque práctico.' },
  { num:'04', title:'Certificación y reportes', desc:'Cada persona obtiene su credencial Certiprof verificable en LinkedIn y tú recibes reportes de avance del equipo.' },
];

const FAQS = [
  { q:'¿Pueden dictar un programa solo para mi empresa?', a:'Sí. Armamos cohortes cerradas in-company con los programas, el calendario y el nivel que mejor se adapten a tu equipo.' },
  { q:'¿Hay descuento por volumen?', a:'Sí. El valor por persona se ajusta según la cantidad de participantes. Un asesor prepara una propuesta a la medida de tu equipo.' },
  { q:'¿Recibo reportes del avance del equipo?', a:'Sí. Entregamos seguimiento y reportes de avance para que tu organización tenga visibilidad del progreso y los resultados de la formación.' },
  { q:'¿Las credenciales las reconocen empresas fuera de LATAM?', a:'Sí. Certiprof es una institución acreditada internacionalmente con presencia en más de 150 países. Cada credencial es verificable públicamente y se agrega al perfil de LinkedIn.' },
  { q:'¿Cómo empezamos?', a:'Escríbenos o agenda una conversación con un asesor. Te respondemos en menos de 24 horas con una propuesta para tu equipo.' },
];

function FaqItem({ faq }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderRadius:'12px', background:C.white, border:'1px solid rgba(0,31,58,.07)', overflow:'hidden' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{ width:'100%', padding:'16px 20px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px', background:'none', border:'none', cursor:'pointer', textAlign:'left' }}
      >
        <span className="d" style={{ fontSize:'14px', fontWeight:700, color:C.navy, lineHeight:1.4 }}>{faq.q}</span>
        <span style={{ fontSize:'18px', color:C.orange, flexShrink:0, transition:'transform .2s', transform:open?'rotate(45deg)':'rotate(0deg)', display:'inline-block', lineHeight:1 }}>+</span>
      </button>
      {open && (
        <div style={{ padding:'0 20px 16px', borderTop:'1px solid rgba(0,31,58,.05)' }}>
          <p style={{ fontSize:'13px', lineHeight:1.7, color:'rgba(0,31,58,.6)', paddingTop:'12px' }}>{faq.a}</p>
        </div>
      )}
    </div>
  );
}

export function WebAcademy() {
  const [stickyOn, setStickyOn] = useState(false);

  useEffect(() => {
    setSEO({
      title: 'HireMeUp Academy | Certificación de Equipos en IA para Empresas',
      description: 'Capacita y certifica a tu equipo con programas internacionales respaldados por Certiprof: IA, agilidad, operación remota y testing. Cohortes cerradas in-company, descuento por volumen y reportes de avance. Credenciales verificables en LinkedIn.',
      canonical: 'https://hiremeupglobal.com/academy',
    });
  }, []);

  useEffect(() => {
    const h = () => setStickyOn(window.scrollY > 150);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const scrollToCerts = () => {
    document.getElementById('ac-certs')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <style>{S(`
        @media(max-width:640px){.ac{grid-template-columns:1fr!important}.ac-pad{padding:40px 20px!important}.ac-cta-split{flex-direction:column!important}}
      `)} </style>
      <Nav />

      {/* ── STICKY BAR ── */}
      {stickyOn && (
        <div style={{ position:'fixed', bottom:0, left:0, right:0, zIndex:200, background:C.navyDark, borderTop:`2px solid ${C.orange}`, padding:'12px 40px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px', flexWrap:'wrap', boxShadow:'0 -4px 24px rgba(0,0,0,.25)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
            <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:C.orange, flexShrink:0 }} />
            <p style={{ fontSize:'13px', fontWeight:600, color:'rgba(255,255,255,.8)', fontFamily:'Inter,sans-serif' }}>Certificación internacional para equipos · Cohortes in-company</p>
          </div>
          <div style={{ display:'flex', gap:'10px', flexShrink:0 }}>
            <a href="/contacto" className="bo" style={{ padding:'9px 20px', borderRadius:'8px', fontSize:'13px' }}>Hablar con un asesor →</a>
            <button onClick={scrollToCerts} style={{ display:'inline-flex', alignItems:'center', padding:'9px 16px', borderRadius:'8px', border:'1.5px solid rgba(255,255,255,.2)', background:'none', cursor:'pointer', color:'white', fontSize:'13px', fontWeight:600, fontFamily:'Inter,sans-serif' }}>Ver programas</button>
          </div>
        </div>
      )}

      {/* ── HERO (compacto, una columna) ── */}
      <section style={{ background:`linear-gradient(150deg,#0a1628 0%,${C.navy} 55%,#0b2d4a 100%)`, padding:'48px 40px 36px', position:'relative', overflow:'hidden' }}>
        {/* Textura de puntos */}
        <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(rgba(255,255,255,.045) 1px, transparent 1px)', backgroundSize:'24px 24px', pointerEvents:'none' }} />
        {/* Glows de profundidad */}
        <div style={{ position:'absolute', top:'-120px', right:'-80px', width:'520px', height:'520px', borderRadius:'50%', background:'radial-gradient(circle,rgba(240,120,32,.12) 0%,transparent 62%)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:'-160px', left:'-100px', width:'460px', height:'460px', borderRadius:'50%', background:'radial-gradient(circle,rgba(37,99,235,.1) 0%,transparent 65%)', pointerEvents:'none' }} />

        <div style={{ maxWidth:'760px', margin:'0 auto', position:'relative', textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center' }}>
          {/* Badge Certiprof */}
          <div style={{ display:'inline-flex', alignItems:'center', gap:'8px', background:'rgba(240,120,32,.12)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'5px 16px', marginBottom:'20px' }}>
            <div style={{ width:'6px', height:'6px', borderRadius:'50%', background:C.orange }} />
            <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.12em', textTransform:'uppercase' }}>Respaldada por Certiprof</span>
            <span style={{ width:'1px', height:'12px', background:'rgba(240,120,32,.3)', display:'inline-block' }} />
            <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.08em' }}>Para empresas y equipos</span>
          </div>

          <h1 className="d" style={{ fontSize:'clamp(2rem,4.6vw,3rem)', fontWeight:900, letterSpacing:'-.03em', color:'white', lineHeight:1.06, marginBottom:'14px' }}>
            Certifica a tu equipo <span style={{ color:C.orange }}>en IA y agilidad.</span>
          </h1>
          <p style={{ fontSize:'15px', color:'rgba(255,255,255,.55)', lineHeight:1.65, maxWidth:'560px', marginBottom:'24px' }}>
            Programas internacionales con respaldo Certiprof para estandarizar habilidades de IA, agilidad y operación remota en tu organización. Cohortes cerradas in-company y credenciales verificables en LinkedIn.
          </p>

          {/* CTAs */}
          <div style={{ display:'flex', gap:'12px', flexWrap:'wrap', justifyContent:'center', marginBottom:'22px' }}>
            <a href="/contacto" className="bo" style={{ padding:'13px 28px', borderRadius:'10px', fontSize:'14px' }}>
              Hablar con un asesor →
            </a>
            <button onClick={scrollToCerts} style={{ display:'inline-flex', alignItems:'center', padding:'13px 22px', borderRadius:'10px', border:'2px solid rgba(255,255,255,.2)', background:'none', cursor:'pointer', color:'white', fontSize:'14px', fontWeight:600, fontFamily:'Inter,sans-serif', transition:'border-color .15s' }}>
              Ver programas
            </button>
          </div>

          {/* Sello Certiprof + stat de alto impacto */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'24px', flexWrap:'wrap' }}>
            <img src={CPLS} alt="Certiprof - Certified Partner for Learning Solutions" style={{ height:'96px', objectFit:'contain' }} />
            <div style={{ width:'1px', height:'56px', background:'rgba(255,255,255,.14)' }} />
            <div style={{ display:'inline-flex', alignItems:'center', gap:'12px' }}>
              <span className="d" style={{ fontSize:'2.2rem', fontWeight:900, color:C.orange, letterSpacing:'-.03em', lineHeight:1 }}>+150</span>
              <span style={{ fontSize:'13px', color:'rgba(255,255,255,.6)', lineHeight:1.35, maxWidth:'180px', textAlign:'left' }}>países donde la credencial de tu equipo es válida</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── PROGRAMAS ── */}
      <section id="ac-certs" className="ac-pad" style={{ padding:'56px 40px', background:C.lightMid }}>
        <div style={{ maxWidth:'900px', margin:'0 auto' }}>
          <h2 className="d" style={{ fontSize:'clamp(2.2rem,5vw,3.2rem)', fontWeight:900, color:C.navy, textAlign:'center', marginBottom:'8px', letterSpacing:'-.03em' }}>
            PROGRAMAS
          </h2>
          <p className="d" style={{ fontSize:'clamp(1.1rem,2.6vw,1.5rem)', fontWeight:700, color:C.navy, textAlign:'center', marginBottom:'12px' }}>
            Certifica a tu equipo con nosotros
          </p>
          <p style={{ fontSize:'14px', color:'rgba(0,31,58,.5)', textAlign:'center', marginBottom:'36px', lineHeight:1.7 }}>
            Cada programa se dicta online con instructor como cohorte cerrado in-company.<br />
            Haz clic en cada uno para ver el detalle.
          </p>
          <div className="ac" style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'18px', marginBottom:'18px' }}>
            {['ai-project-management','ai-product-manager','remote-operations-ai-support','artificial-intelligence-professional','agile-coach'].map(slug => (
              <CertCard key={slug} cert={COURSE_BY_SLUG[slug]} />
            ))}
          </div>
          <TesterTrackCard />
        </div>
      </section>

      {/* ── FRANJA EMPRESAS ── */}
      <div style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'32px 40px' }}>
        <div style={{ maxWidth:'900px', margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'24px', flexWrap:'wrap' }}>
          <div>
            <div style={{ display:'inline-flex', alignItems:'center', gap:'6px', background:'rgba(240,120,32,.15)', border:'1px solid rgba(240,120,32,.3)', borderRadius:'20px', padding:'3px 12px', marginBottom:'8px' }}>
              <span style={{ fontSize:'9px', fontWeight:700, color:C.orange, letterSpacing:'.1em', textTransform:'uppercase' }}>Para empresas y equipos</span>
            </div>
            <p className="d" style={{ fontSize:'18px', fontWeight:800, color:'white', lineHeight:1.2, marginBottom:'4px' }}>¿Quieres certificar a tu equipo?</p>
            <p style={{ fontSize:'13px', color:'rgba(255,255,255,.45)', fontFamily:'Inter,sans-serif' }}>Cohortes cerradas in-company, descuento por volumen y reportes de avance del equipo.</p>
          </div>
          <a href="/contacto" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px', flexShrink:0 }}>Hablar con un asesor →</a>
        </div>
      </div>

      {/* ── CÓMO FUNCIONA ── */}
      <section className="ac-pad" style={{ padding:'56px 40px', background:C.lightMid }}>
        <div style={{ maxWidth:'900px', margin:'0 auto' }}>
          <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'10px', textAlign:'center' }}>EL PROCESO</p>
          <h2 className="d" style={{ fontSize:'clamp(1.5rem,3vw,2rem)', fontWeight:800, color:C.navy, textAlign:'center', marginBottom:'40px', letterSpacing:'-.02em' }}>
            ¿Cómo funciona?
          </h2>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:'0', position:'relative' }}>
            {PASOS.map((p, i) => (
              <div key={p.num} style={{ display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center', padding:'0 16px', position:'relative' }}>
                {/* Conector entre pasos */}
                {i < PASOS.length - 1 && (
                  <div style={{ position:'absolute', top:'24px', left:'calc(50% + 28px)', right:'-50%', height:'2px', background:`linear-gradient(90deg,${C.orange}50,transparent)`, zIndex:0 }} />
                )}
                <div style={{ width:'48px', height:'48px', borderRadius:'50%', background:`linear-gradient(135deg,${C.orange},${C.orangeDk})`, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'16px', position:'relative', zIndex:1, flexShrink:0 }}>
                  <span className="d" style={{ fontSize:'15px', fontWeight:900, color:'white' }}>{p.num}</span>
                </div>
                <p className="d" style={{ fontSize:'14px', fontWeight:800, color:C.navy, marginBottom:'8px', lineHeight:1.3 }}>{p.title}</p>
                <p style={{ fontSize:'12px', lineHeight:1.6, color:'rgba(0,31,58,.5)' }}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="ac-pad" style={{ padding:'60px 40px', background:C.light }}>
        <div style={{ maxWidth:'720px', margin:'0 auto' }}>
          <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'10px', textAlign:'center' }}>PREGUNTAS FRECUENTES</p>
          <h2 className="d" style={{ fontSize:'clamp(1.5rem,3vw,2rem)', fontWeight:800, color:C.navy, textAlign:'center', marginBottom:'32px', letterSpacing:'-.02em' }}>
            Resolvemos tus dudas
          </h2>
          <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
            {FAQS.map((faq, i) => <FaqItem key={i} faq={faq} />)}
          </div>
          <p style={{ textAlign:'center', fontSize:'13px', color:'rgba(0,31,58,.4)', marginTop:'24px' }}>
            ¿Tienes otra pregunta? <a href="/contacto" style={{ color:C.orange, fontWeight:700 }}>Escríbenos directamente →</a>
          </p>
        </div>
      </section>

      {/* ── CTA FINAL SPLIT ── */}
      <section className="ac-pad" style={{ padding:'48px 40px', background:C.navyDark }}>
        <div className="ac-cta-split" style={{ maxWidth:'900px', margin:'0 auto', display:'flex', gap:'16px' }}>
          {/* Tarjeta equipo */}
          <div style={{ flex:1, borderRadius:'16px', padding:'28px', background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, border:'1px solid rgba(255,255,255,.07)', display:'flex', flexDirection:'column' }}>
            <span style={{ fontSize:'10px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:'rgba(255,255,255,.4)', marginBottom:'10px', fontFamily:'Inter,sans-serif' }}>Cohorte cerrada</span>
            <p className="d" style={{ fontSize:'18px', fontWeight:800, color:'white', lineHeight:1.2, marginBottom:'8px' }}>
              Certifica a tu equipo<br /><span style={{ color:C.orange }}>con un asesor dedicado.</span>
            </p>
            <p style={{ fontSize:'13px', color:'rgba(255,255,255,.45)', lineHeight:1.6, marginBottom:'20px', flex:1 }}>
              Armamos una cohorte cerrada in-company con el calendario y el nivel de tu equipo. Descuento por volumen y reportes de avance.
            </p>
            <a href="/contacto" className="bo" style={{ padding:'11px 22px', borderRadius:'9px', fontSize:'13px', alignSelf:'flex-start' }}>
              Hablar con un asesor →
            </a>
          </div>
          {/* Tarjeta plan a medida */}
          <div style={{ flex:1, borderRadius:'16px', padding:'28px', background:`linear-gradient(135deg,rgba(240,120,32,.12),rgba(154,70,0,.15))`, border:`1px solid rgba(240,120,32,.2)`, display:'flex', flexDirection:'column' }}>
            <span style={{ fontSize:'10px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:C.orange, marginBottom:'10px', fontFamily:'Inter,sans-serif' }}>Plan a medida</span>
            <p className="d" style={{ fontSize:'18px', fontWeight:800, color:'white', lineHeight:1.2, marginBottom:'8px' }}>
              Un itinerario de IA<br /><span style={{ color:C.orange }}>para tu organización.</span>
            </p>
            <p style={{ fontSize:'13px', color:'rgba(255,255,255,.45)', lineHeight:1.6, marginBottom:'20px', flex:1 }}>
              Combinamos varios programas según los objetivos de tu empresa, con seguimiento de resultados y credenciales verificables en LinkedIn.
            </p>
            <a href="/contacto" className="bo" style={{ padding:'11px 22px', borderRadius:'9px', fontSize:'13px', alignSelf:'flex-start' }}>
              Diseñar un plan →
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

// ─── ACADEMY · DETALLE DE CURSO ────────────────────────────────────────────────
function CourseSection({ title, color, children }) {
  return (
    <div style={{ marginBottom:'32px' }}>
      <h2 className="d" style={{ fontSize:'15px', fontWeight:800, color:C.navy, marginBottom:'14px', display:'flex', alignItems:'center', gap:'8px' }}>
        <span style={{ width:'6px', height:'18px', borderRadius:'3px', background:color, display:'inline-block' }} />
        {title}
      </h2>
      {children}
    </div>
  );
}

function CourseList({ items, color }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
      {items.map((it, i) => (
        <div key={i} style={{ display:'flex', gap:'10px', alignItems:'flex-start' }}>
          <span style={{ color, fontSize:'14px', flexShrink:0, marginTop:'1px' }}>✓</span>
          <span style={{ fontSize:'14px', lineHeight:1.6, color:'rgba(0,31,58,.7)' }}>{it}</span>
        </div>
      ))}
    </div>
  );
}

export function WebAcademyCourse() {
  const { slug } = useParams();
  const course = COURSE_BY_SLUG[slug];

  useEffect(() => {
    if (course) {
      setSEO({
        title: `${course.title} | HireMeUp Academy`,
        description: `${course.detail?.tagline || course.desc} Certificación internacional Certiprof, verificable en LinkedIn. Disponible como cohorte cerrada in-company para equipos.`,
        canonical: `https://hiremeupglobal.com/academy/${slug}`,
      });
    } else {
      setSEO({ title: 'Programa no encontrado | HireMeUp Academy', description: 'El programa que buscas no está disponible.', canonical: 'https://hiremeupglobal.com/academy' });
    }
    window.scrollTo(0, 0);
  }, [course, slug]);

  if (!course) {
    return (
      <>
        <style>{S()}</style>
        <Nav />
        <section style={{ minHeight:'60vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'80px 24px', textAlign:'center' }}>
          <h1 className="d" style={{ fontSize:'1.8rem', fontWeight:800, color:C.navy, marginBottom:'12px' }}>Programa no encontrado</h1>
          <p style={{ fontSize:'14px', color:'rgba(0,31,58,.5)', marginBottom:'24px' }}>El programa que buscas no existe o cambió de dirección.</p>
          <a href="/academy" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px' }}>Ver todos los programas →</a>
        </section>
        <Footer />
      </>
    );
  }

  const d = course.detail || {};

  return (
    <>
      <style>{S(`
        @media(max-width:860px){.acd-grid{grid-template-columns:1fr!important}.acd-aside{position:static!important}}
        @media(max-width:640px){.ac-pad{padding:40px 20px!important}}
      `)}</style>
      <Nav />

      {/* HERO */}
      <section style={{ background:`linear-gradient(150deg,#0a1628 0%,${C.navy} 60%,#0b2d4a 100%)`, padding:'40px 40px 48px', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(rgba(255,255,255,.04) 1px, transparent 1px)', backgroundSize:'24px 24px', pointerEvents:'none' }} />
        <div style={{ position:'absolute', top:'-120px', right:'-80px', width:'460px', height:'460px', borderRadius:'50%', background:`radial-gradient(circle,${course.color}22 0%,transparent 64%)`, pointerEvents:'none' }} />
        <div style={{ maxWidth:'900px', margin:'0 auto', position:'relative' }}>
          <a href="/academy" style={{ fontSize:'13px', color:'rgba(255,255,255,.5)', fontFamily:'Inter,sans-serif', display:'inline-block', marginBottom:'20px' }}>← Volver a programas</a>
          <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'14px', flexWrap:'wrap' }}>
            <span style={{ fontSize:'10px', fontWeight:700, padding:'4px 10px', borderRadius:'20px', background:`${course.color}22`, color:'white', border:`1px solid ${course.color}55`, letterSpacing:'.06em' }}>{course.code}</span>
            <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.1em', textTransform:'uppercase' }}>Respaldada por Certiprof</span>
          </div>
          <h1 className="d" style={{ fontSize:'clamp(1.8rem,4vw,2.6rem)', fontWeight:900, letterSpacing:'-.03em', color:'white', lineHeight:1.1, marginBottom:'12px' }}>{course.title}</h1>
          {d.tagline && <p style={{ fontSize:'16px', color:'rgba(255,255,255,.6)', lineHeight:1.6, maxWidth:'560px', marginBottom:'24px' }}>{d.tagline}</p>}
          {/* Facts chips */}
          {d.facts && (
            <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'28px' }}>
              {d.facts.map((f,i) => (
                <span key={i} style={{ fontSize:'12px', fontWeight:600, color:'rgba(255,255,255,.7)', background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.12)', borderRadius:'8px', padding:'7px 12px' }}>{f}</span>
              ))}
            </div>
          )}
          {/* CTAs */}
          <div style={{ display:'flex', gap:'12px', flexWrap:'wrap' }}>
            <a href="/contacto" className="bo" style={{ padding:'13px 26px', borderRadius:'10px', fontSize:'14px' }}>Hablar con un asesor →</a>
          </div>
        </div>
      </section>

      {/* CONTENIDO */}
      <section className="ac-pad" style={{ padding:'52px 40px', background:C.light }}>
        <div className="acd-grid" style={{ maxWidth:'900px', margin:'0 auto', display:'grid', gridTemplateColumns:'1fr 280px', gap:'40px', alignItems:'start' }}>
          {/* Columna principal */}
          <div>
            {d.about && (
              <CourseSection title="Acerca del programa" color={course.color}>
                <p style={{ fontSize:'14px', lineHeight:1.75, color:'rgba(0,31,58,.7)' }}>{d.about}</p>
              </CourseSection>
            )}
            {d.forWhom && d.forWhom.length > 0 && (
              <CourseSection title="¿A quién está dirigido?" color={course.color}>
                <CourseList items={d.forWhom} color={course.color} />
              </CourseSection>
            )}
            {d.objectives && d.objectives.length > 0 && (
              <CourseSection title="Lo que aprenderás" color={course.color}>
                <CourseList items={d.objectives} color={course.color} />
              </CourseSection>
            )}
            {d.modules && d.modules.length > 0 && (
              <CourseSection title="Esquema de módulos" color={course.color}>
                <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
                  {d.modules.map((m,i) => (
                    <div key={i} style={{ display:'flex', gap:'12px', alignItems:'flex-start', background:C.white, border:'1px solid rgba(0,31,58,.07)', borderRadius:'10px', padding:'14px 16px' }}>
                      <span className="d" style={{ fontSize:'13px', fontWeight:900, color:course.color, flexShrink:0, width:'22px' }}>{String(i+1).padStart(2,'0')}</span>
                      <span style={{ fontSize:'13px', lineHeight:1.6, color:'rgba(0,31,58,.7)' }}>{m}</span>
                    </div>
                  ))}
                </div>
              </CourseSection>
            )}
            {d.roles && d.roles.length > 0 && (
              <CourseSection title="Roles que habilita" color={course.color}>
                <CourseList items={d.roles} color={course.color} />
              </CourseSection>
            )}
            {d.requisitos && d.requisitos.length > 0 && (
              <CourseSection title="Requisitos de certificación" color={course.color}>
                <CourseList items={d.requisitos} color={course.color} />
              </CourseSection>
            )}
            {d.materials && (
              <CourseSection title="Materiales incluidos" color={course.color}>
                <p style={{ fontSize:'14px', lineHeight:1.7, color:'rgba(0,31,58,.7)' }}>{d.materials}</p>
              </CourseSection>
            )}
            <CourseSection title="Certificación" color={course.color}>
              <div style={{ display:'flex', alignItems:'center', gap:'18px', flexWrap:'wrap' }}>
                <img src={CPLS} alt="Certiprof - Certified Partner for Learning Solutions" style={{ height:'104px', objectFit:'contain', flexShrink:0 }} />
                <p style={{ flex:1, minWidth:'240px', fontSize:'14px', lineHeight:1.7, color:'rgba(0,31,58,.7)' }}>
                  Credencial profesional internacional emitida por Certiprof, válida en más de 150 países y verificable públicamente en LinkedIn.
                </p>
              </div>
            </CourseSection>
          </div>

          {/* Aside CTA B2B (sticky en desktop) */}
          <aside className="acd-aside" style={{ position:'sticky', top:'24px' }}>
            <div style={{ borderRadius:'16px', background:`linear-gradient(150deg,${C.navy},${C.navyMid})`, padding:'24px', boxShadow:'0 12px 32px rgba(0,31,58,.12)' }}>
              <span style={{ fontSize:'10px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:C.orange, fontFamily:'Inter,sans-serif' }}>Para tu equipo</span>
              <p className="d" style={{ fontSize:'16px', fontWeight:800, color:'white', lineHeight:1.3, margin:'8px 0 12px' }}>Lleva este programa a tu organización</p>
              <p style={{ fontSize:'12px', color:'rgba(255,255,255,.5)', lineHeight:1.6, marginBottom:'18px' }}>
                Cohorte cerrada in-company, descuento por volumen y reportes de avance del equipo.
              </p>
              <a href="/contacto" className="bo" style={{ width:'100%', justifyContent:'center', padding:'12px', borderRadius:'9px', fontSize:'13px', marginBottom:'10px' }}>Hablar con un asesor →</a>
              {course.brochure && (
                <a href={course.brochure} target="_blank" rel="noopener noreferrer" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'7px', width:'100%', padding:'12px', borderRadius:'9px', background:'#38bdf8', color:'#001f3a', fontSize:'13px', fontWeight:800, fontFamily:'Inter,sans-serif', boxShadow:'0 4px 14px rgba(56,189,248,.35)' }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  Descargar brochure
                </a>
              )}
            </div>
          </aside>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="ac-pad" style={{ padding:'48px 40px', background:C.navyDark, textAlign:'center' }}>
        <div style={{ maxWidth:'600px', margin:'0 auto' }}>
          <h2 className="d" style={{ fontSize:'clamp(1.5rem,3vw,2rem)', fontWeight:800, color:'white', lineHeight:1.2, marginBottom:'12px' }}>
            ¿Listo para certificar a tu equipo?
          </h2>
          <p style={{ fontSize:'14px', color:'rgba(255,255,255,.5)', lineHeight:1.6, marginBottom:'24px' }}>
            Un asesor prepara una propuesta a la medida de tu organización en menos de 24 horas.
          </p>
          <div style={{ display:'flex', gap:'12px', justifyContent:'center', flexWrap:'wrap' }}>
            <a href="/contacto" className="bo" style={{ padding:'13px 28px', borderRadius:'10px', fontSize:'14px' }}>Hablar con un asesor →</a>
            <a href="/academy" style={{ display:'inline-flex', alignItems:'center', padding:'13px 22px', borderRadius:'10px', border:'2px solid rgba(255,255,255,.2)', color:'white', fontSize:'14px', fontWeight:600, fontFamily:'Inter,sans-serif' }}>Ver otros programas</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

// ─── ACADEMY · TRACK AI TESTER (3 NIVELES) ─────────────────────────────────────
export function WebAcademyTester() {
  useEffect(() => {
    setSEO({
      title: 'AI Tester Specialist | Track de 3 niveles | HireMeUp Academy',
      description: 'Itinerario AI Tester en 3 niveles (Junior, Semi Senior y Senior) para llevar a tu equipo de QA del testing manual al liderazgo de calidad con IA. Certificación internacional Certiprof, verificable en LinkedIn.',
      canonical: 'https://hiremeupglobal.com/academy/ai-tester',
    });
    window.scrollTo(0, 0);
  }, []);

  const facts = ['3 niveles', '4 sesiones por nivel', 'Online · En vivo', 'Certificación Certiprof'];

  return (
    <>
      <style>{S(`
        @media(max-width:860px){.act-levels{grid-template-columns:1fr!important}}
        @media(max-width:640px){.ac-pad{padding:40px 20px!important}}
      `)}</style>
      <Nav />

      {/* HERO */}
      <section style={{ background:`linear-gradient(150deg,#0a1628 0%,${C.navy} 60%,#0b2d4a 100%)`, padding:'40px 40px 48px', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(rgba(255,255,255,.04) 1px, transparent 1px)', backgroundSize:'24px 24px', pointerEvents:'none' }} />
        <div style={{ position:'absolute', top:'-120px', right:'-80px', width:'460px', height:'460px', borderRadius:'50%', background:'radial-gradient(circle,rgba(240,120,32,.16) 0%,transparent 64%)', pointerEvents:'none' }} />
        <div style={{ maxWidth:'900px', margin:'0 auto', position:'relative' }}>
          <a href="/academy" style={{ fontSize:'13px', color:'rgba(255,255,255,.5)', fontFamily:'Inter,sans-serif', display:'inline-block', marginBottom:'20px' }}>← Volver a programas</a>
          <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'14px', flexWrap:'wrap' }}>
            <span style={{ fontSize:'10px', fontWeight:700, padding:'4px 10px', borderRadius:'20px', background:'rgba(240,120,32,.18)', color:'white', border:'1px solid rgba(240,120,32,.45)', letterSpacing:'.06em', textTransform:'uppercase' }}>Track · 3 niveles</span>
            <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.1em', textTransform:'uppercase' }}>Respaldada por Certiprof</span>
          </div>
          <h1 className="d" style={{ fontSize:'clamp(1.8rem,4vw,2.6rem)', fontWeight:900, letterSpacing:'-.03em', color:'white', lineHeight:1.1, marginBottom:'12px' }}>AI Tester Specialist</h1>
          <p style={{ fontSize:'16px', color:'rgba(255,255,255,.6)', lineHeight:1.6, maxWidth:'600px', marginBottom:'24px' }}>
            Un itinerario en 3 niveles para llevar a tu equipo de QA del testing manual al liderazgo de calidad con IA. Cada nivel certifica de forma independiente.
          </p>
          <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'28px' }}>
            {facts.map((f,i) => (
              <span key={i} style={{ fontSize:'12px', fontWeight:600, color:'rgba(255,255,255,.7)', background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.12)', borderRadius:'8px', padding:'7px 12px' }}>{f}</span>
            ))}
          </div>
          <div style={{ display:'flex', gap:'12px', flexWrap:'wrap' }}>
            <a href="/contacto" className="bo" style={{ padding:'13px 26px', borderRadius:'10px', fontSize:'14px' }}>Hablar con un asesor →</a>
            <a href="https://drive.google.com/file/d/1nStcv2Pjtv5sSyuk4Ukl90GrChraOSOB/view?usp=sharing" target="_blank" rel="noopener noreferrer" style={{ display:'inline-flex', alignItems:'center', gap:'7px', padding:'13px 22px', borderRadius:'10px', background:'#38bdf8', color:'#001f3a', fontSize:'14px', fontWeight:800, fontFamily:'Inter,sans-serif', boxShadow:'0 4px 14px rgba(56,189,248,.35)' }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Descargar brochure
            </a>
          </div>
          {/* Sello Certiprof */}
          <div style={{ display:'flex', alignItems:'center', gap:'14px', marginTop:'28px' }}>
            <img src={CPLS} alt="Certiprof - Certified Partner for Learning Solutions" style={{ height:'82px', objectFit:'contain' }} />
            <span style={{ fontSize:'12px', color:'rgba(255,255,255,.5)', maxWidth:'220px', lineHeight:1.45 }}>Credencial internacional Certiprof, verificable en LinkedIn.</span>
          </div>
        </div>
      </section>

      {/* NIVELES */}
      <section className="ac-pad" style={{ padding:'52px 40px', background:C.light }}>
        <div style={{ maxWidth:'900px', margin:'0 auto' }}>
          <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'10px', textAlign:'center' }}>ELIGE EL NIVEL</p>
          <h2 className="d" style={{ fontSize:'clamp(1.4rem,3vw,1.9rem)', fontWeight:800, color:C.navy, textAlign:'center', marginBottom:'8px', letterSpacing:'-.02em' }}>
            Los 3 niveles del track
          </h2>
          <p style={{ fontSize:'14px', color:'rgba(0,31,58,.45)', textAlign:'center', marginBottom:'36px' }}>
            Cada nivel se certifica por separado. Haz clic para ver el detalle de cada uno.
          </p>
          <div className="act-levels" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px' }}>
            {TESTER_TRACK.map(t => (
              <a key={t.nivel} href={`/academy/${t.slug}`} className="ch" style={{ borderRadius:'14px', padding:'22px', background:C.white, border:`1px solid ${t.color}25`, boxShadow:'0 4px 20px rgba(0,31,58,.06)', display:'flex', flexDirection:'column', textDecoration:'none' }}>
                <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'10px' }}>
                  <span style={{ fontSize:'10px', fontWeight:700, padding:'3px 9px', borderRadius:'20px', background:t.color, color:'white' }}>{t.badge}</span>
                  <span className="d" style={{ fontSize:'12px', fontWeight:800, color:t.color }}>{t.nivel}</span>
                </div>
                <h3 className="d" style={{ fontSize:'15px', fontWeight:800, color:C.navy, marginBottom:'8px', lineHeight:1.3 }}>{t.title}</h3>
                <span style={{ display:'inline-flex', alignItems:'center', fontSize:'10px', fontWeight:600, color:'rgba(0,31,58,.4)', background:'rgba(0,31,58,.05)', borderRadius:'6px', padding:'3px 8px', marginBottom:'10px', alignSelf:'flex-start' }}>🕐 {t.duration} · En vivo</span>
                <p style={{ fontSize:'13px', lineHeight:1.6, color:'rgba(0,31,58,.6)', marginBottom:'16px', flex:1 }}>{t.desc}</p>
                <span className="d" style={{ fontSize:'13px', fontWeight:800, color:t.color }}>Ver programa →</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="ac-pad" style={{ padding:'48px 40px', background:C.navyDark, textAlign:'center' }}>
        <div style={{ maxWidth:'600px', margin:'0 auto' }}>
          <h2 className="d" style={{ fontSize:'clamp(1.5rem,3vw,2rem)', fontWeight:800, color:'white', lineHeight:1.2, marginBottom:'12px' }}>
            ¿Quieres formar a tu equipo de QA con IA?
          </h2>
          <p style={{ fontSize:'14px', color:'rgba(255,255,255,.5)', lineHeight:1.6, marginBottom:'24px' }}>
            Diseñamos una cohorte cerrada con el nivel adecuado para cada persona. Un asesor te arma la propuesta en menos de 24 horas.
          </p>
          <div style={{ display:'flex', gap:'12px', justifyContent:'center', flexWrap:'wrap' }}>
            <a href="/contacto" className="bo" style={{ padding:'13px 28px', borderRadius:'10px', fontSize:'14px' }}>Hablar con un asesor →</a>
            <a href="/academy" style={{ display:'inline-flex', alignItems:'center', padding:'13px 22px', borderRadius:'10px', border:'2px solid rgba(255,255,255,.2)', color:'white', fontSize:'14px', fontWeight:600, fontFamily:'Inter,sans-serif' }}>Ver otros programas</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

// ─── NOSOTROS ─────────────────────────────────────────────────────────────────
export function WebNosotros() {
  useEffect(() => {
    setSEO({
      title: 'Sobre HireMeUp | Nuestra Misión de Empleabilidad Remota en LATAM',
      description: 'Conoce la historia, misión y valores de HireMeUp. Fundada por Mathius Ballesteros para transformar cómo los profesionales de LATAM acceden a oportunidades laborales globales.',
      canonical: 'https://hiremeupglobal.com/nosotros',
    });
  }, []);
  return (
    <>
      <style>{S()}</style>
      <Nav />
      <section style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'80px 40px' }}>
        <div style={{ maxWidth:'900px', margin:'0 auto', display:'flex', gap:'60px', alignItems:'center', flexWrap:'wrap' }}>
          <div style={{ flex:'0 0 200px', display:'flex', justifyContent:'center' }}>
            <div style={{ width:'160px', height:'200px', borderRadius:'20px', background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'14px' }}>
              <div style={{ width:'72px', height:'72px', borderRadius:'50%', background:`linear-gradient(135deg,${C.orange},${C.orangeDk})`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <span className="d" style={{ fontSize:'28px', fontWeight:900, color:'white' }}>M</span>
              </div>
              <div style={{ textAlign:'center' }}>
                <p className="d" style={{ fontSize:'13px', fontWeight:800, color:'white' }}>Mathius Ballesteros</p>
                <p style={{ fontSize:'11px', color:'rgba(255,255,255,.4)', marginTop:'3px' }}>Fundador - HireMeUp</p>
              </div>
            </div>
          </div>
          <div style={{ flex:1, minWidth:'260px' }}>
            <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'12px' }}>QUIENES SOMOS</p>
            <h1 className="d" style={{ fontSize:'clamp(1.8rem,4vw,2.6rem)', fontWeight:900, letterSpacing:'-.02em', color:'white', lineHeight:1.1, marginBottom:'16px' }}>
              Nacimos para cambiar<br /><span style={{ color:C.orange }}>cómo las personas se enfrentan al empleo.</span>
            </h1>
            <p style={{ fontSize:'15px', lineHeight:1.8, color:'rgba(255,255,255,.55)' }}>
              HireMeUp nació de ver a miles de profesionales talentosos ser descartados, no por falta de capacidad, sino porque no sabían cómo mostrar su valor. Creamos una ruta real de empleabilidad para que dejes de depender de la suerte y empieces a ser elegido con estrategia.
            </p>
          </div>
        </div>
      </section>
      <section style={{ padding:'60px 40px', background:C.light }}>
        <div style={{ maxWidth:'900px', margin:'0 auto' }}>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:'20px', marginBottom:'48px' }}>
            {[
              { title:'Misión', color:'#2563eb', bg:'#eff6ff', text:'Impulsamos a las personas a convertirse en profesionales elegidos no por suerte, sino por estrategia, autenticidad y valor.' },
              { title:'Visión', color:C.orange, bg:'#fff7ed', text:'Redefinir el futuro del trabajo en los mercados hispanohablantes, empoderando a millones a diseñar carreras con sentido.' },
              { title:'Valores', color:'#0f766e', bg:'#f0fdfa', text:'Las personas en el centro, con estrategias reales que empoderan. No maquillamos el sistema: lo enfrentamos con verdad, excelencia y visión regional.' },
            ].map(v => (
              <div key={v.title} style={{ borderRadius:'16px', padding:'24px', background:v.bg, border:`1px solid ${v.color}20` }}>
                <p className="d" style={{ fontSize:'16px', fontWeight:800, color:v.color, marginBottom:'10px' }}>{v.title}</p>
                <p style={{ fontSize:'14px', lineHeight:1.7, color:'rgba(0,31,58,.7)' }}>{v.text}</p>
              </div>
            ))}
          </div>
          <div style={{ marginBottom:'48px' }}>
            <h2 className="d" style={{ fontSize:'22px', fontWeight:800, color:C.navy, marginBottom:'24px' }}>¿Por qué nuestra estrategia marca la diferencia?</h2>
            <p style={{ fontSize:'15px', lineHeight:1.8, color:'rgba(0,31,58,.6)', marginBottom:'24px' }}>
              HireMeUp fue creado por alguien que ha estado en ambos lados del proceso: como profesional que buscó y como experto que contrató. Sabemos lo que frustra, lo que no funciona y lo que realmente te hace avanzar.
            </p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:'16px' }}>
              {[
                { title:'Conocemos el sistema', text:'Creamos soluciones que responden a sus verdaderas reglas, no a suposiciones.' },
                { title:'Mostramos tu valor', text:'Se trata de comunicar mejor lo que te hace único, no de postular más.' },
                { title:'Herramientas prácticas', text:'Todo lo que ofrecemos tiene una sola función: ayudarte a avanzar con dirección.' },
                { title:'Acompañamiento humano', text:'Sin filtros ni rodeos. Decimos lo que necesitas saber para decidir con poder.' },
              ].map((f,i) => (
                <div key={i} style={{ borderRadius:'12px', padding:'20px', background:C.white, boxShadow:'0 4px 16px rgba(0,31,58,.05)' }}>
                  <p className="d" style={{ fontSize:'14px', fontWeight:800, color:C.navy, marginBottom:'6px' }}>{f.title}</p>
                  <p style={{ fontSize:'13px', lineHeight:1.6, color:'rgba(0,31,58,.55)' }}>{f.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div style={{ borderRadius:'16px', padding:'32px 40px', background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, textAlign:'center' }}>
            <p className="d" style={{ fontSize:'20px', fontWeight:800, color:'white', marginBottom:'8px' }}>Tu carrera no se improvisa. Se diseña.</p>
            <p style={{ fontSize:'14px', color:'rgba(255,255,255,.5)', marginBottom:'24px' }}>El próximo profesional elegido puedes ser tú.</p>
            <div style={{ display:'flex', gap:'12px', justifyContent:'center', flexWrap:'wrap' }}>
              <a href="https://app.hiremeupglobal.com/register" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px' }}>Empezar gratis</a>
              <a href="/contacto" style={{ display:'inline-flex', alignItems:'center', padding:'12px 20px', borderRadius:'10px', border:'2px solid rgba(255,255,255,.3)', color:'white', fontSize:'14px', fontWeight:600, fontFamily:'Inter,sans-serif' }}>Contactar</a>
            </div>
          </div>
          <div style={{ display:'flex', gap:'12px', marginTop:'28px', flexWrap:'wrap' }}>
            <a href="https://www.instagram.com/hiremeupglobal/" target="_blank" rel="noopener noreferrer" className="bo" style={{ padding:'10px 20px', borderRadius:'8px', fontSize:'13px' }}>Instagram</a>
            <a href="https://www.linkedin.com/company/hiremeupglobal/" target="_blank" rel="noopener noreferrer" style={{ display:'inline-flex', alignItems:'center', padding:'10px 20px', borderRadius:'8px', background:'#0077b5', color:'white', fontSize:'13px', fontWeight:700 }}>LinkedIn</a>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

// ─── CONTACTO ─────────────────────────────────────────────────────────────────
export function WebContacto() {
  const [form, setForm]     = useState({ nombre:'', email:'', mensaje:'' });
  const [status, setStatus] = useState('idle');
  const [error, setError]   = useState('');

  useEffect(() => {
    setSEO({
      title: 'Contacto | HireMeUp',
      description: 'Comunícate con el equipo de HireMeUp. Estamos disponibles para resolver tus preguntas sobre empleabilidad remota, servicios y certificaciones internacionales.',
      canonical: 'https://hiremeupglobal.com/contacto',
    });
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.nombre || !form.email || !form.mensaje) { setError('Completa todos los campos.'); return; }
    setStatus('loading'); setError('');
    try {
      const res  = await fetch('https://api.web3forms.com/submit', {
        method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body: JSON.stringify({ access_key:'e9a1acca-ceec-4c3a-8c57-9f7a8d0f5c7c', name:form.nombre, email:form.email, message:form.mensaje, subject:`Mensaje de contacto - ${form.nombre}` }),
      });
      const data = await res.json();
      if (data.success) setStatus('success'); else { setStatus('error'); setError('Error al enviar. Intenta de nuevo.'); }
    } catch { setStatus('error'); setError('Error de conexion.'); }
  };

  return (
    <>
      <style>{S()}</style>
      <Nav />
      <section style={{ minHeight:'calc(100vh - 56px)', background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, display:'flex', alignItems:'center', padding:'60px 24px' }}>
        <div style={{ maxWidth:'520px', margin:'0 auto', width:'100%' }}>
          <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'12px', textAlign:'center' }}>CONTACTO</p>
          <h1 className="d" style={{ fontSize:'clamp(1.8rem,4vw,2.4rem)', fontWeight:900, letterSpacing:'-.02em', color:'white', textAlign:'center', marginBottom:'32px' }}>Escríbenos</h1>
          <div style={{ background:C.white, borderRadius:'20px', padding:'36px 32px' }}>
            {status === 'success' ? (
              <div style={{ textAlign:'center', padding:'20px 0' }}>
                <div style={{ width:'64px', height:'64px', borderRadius:'50%', background:'rgba(15,118,110,.1)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                  <span style={{ fontSize:'28px', color:'#0f766e' }}>✓</span>
                </div>
                <h3 className="d" style={{ fontSize:'20px', fontWeight:800, color:C.navy, marginBottom:'8px' }}>Mensaje recibido</h3>
                <p style={{ fontSize:'14px', color:'rgba(0,31,58,.55)', marginBottom:'20px' }}>Te respondemos pronto a tu correo.</p>
                <a href="/" style={{ fontSize:'13px', color:C.orange, fontWeight:600 }}>Volver al inicio</a>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
                <div>
                  <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>Nombre completo</label>
                  <input type="text" value={form.nombre} onChange={e => setForm({...form, nombre:e.target.value})} placeholder="Tu nombre" className="field" />
                </div>
                <div>
                  <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>Correo electrónico</label>
                  <input type="email" value={form.email} onChange={e => setForm({...form, email:e.target.value})} placeholder="tu@email.com" className="field" />
                </div>
                <div>
                  <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>Mensaje</label>
                  <textarea value={form.mensaje} onChange={e => setForm({...form, mensaje:e.target.value})} placeholder="¿En qué podemos ayudarte?" rows={5} className="field" style={{ resize:'vertical' }} />
                </div>
                {error && <p style={{ fontSize:'12px', color:'#dc2626', background:'#fef2f2', padding:'8px 12px', borderRadius:'6px' }}>{error}</p>}
                <button type="submit" disabled={status==='loading'} className="bo"
                  style={{ padding:'13px', borderRadius:'10px', fontSize:'14px', justifyContent:'center', opacity:status==='loading'?.7:1, width:'100%' }}>
                  {status==='loading'?'Enviando...':'Enviar mensaje'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

// ─── 404 ──────────────────────────────────────────────────────────────────────

export function Web404() {
  useEffect(() => {
    setSEO({
      title: 'Página no encontrada | HireMeUp',
      description: 'La página que buscas no existe o cambió de dirección. Explora los servicios de HireMeUp o los programas de HireMeUp Academy.',
      canonical: 'https://hiremeupglobal.com/',
    });
  }, []);

  return (
    <>
      <style>{S()}</style>
      <Nav />
      <section style={{ minHeight:'calc(100vh - 132px)', background:C.light, display:'flex', alignItems:'center', justifyContent:'center', padding:'60px 24px' }}>
        <div style={{ textAlign:'center', maxWidth:'480px' }}>
          <p className="d" style={{ fontSize:'clamp(4rem,12vw,7rem)', fontWeight:900, letterSpacing:'-.04em', lineHeight:1, color:C.navy, marginBottom:'8px' }}>
            4<span style={{ color:C.orange }}>0</span>4
          </p>
          <h1 className="d" style={{ fontSize:'22px', fontWeight:800, color:C.navy, marginBottom:'12px' }}>Esta página no existe</h1>
          <p style={{ fontSize:'15px', lineHeight:1.7, color:'rgba(0,31,58,.55)', marginBottom:'28px' }}>
            Es posible que el enlace haya cambiado de dirección. Te dejamos los caminos más útiles para seguir.
          </p>
          <div style={{ display:'flex', gap:'12px', justifyContent:'center', flexWrap:'wrap' }}>
            <a href="/" className="bo" style={{ padding:'12px 22px', borderRadius:'10px', fontSize:'14px' }}>Ir al inicio</a>
            <a href="/academy" style={{ display:'inline-flex', alignItems:'center', padding:'12px 22px', borderRadius:'10px', fontSize:'14px', fontWeight:700, color:C.navy, border:'1.5px solid rgba(0,31,58,.18)', background:C.white }}>Ver la Academy</a>
          </div>
          <p style={{ fontSize:'13px', color:'rgba(0,31,58,.4)', marginTop:'24px' }}>
            ¿Buscabas algo puntual? <a href="/contacto" style={{ color:C.orange, fontWeight:600 }}>Escríbenos</a>.
          </p>
        </div>
      </section>
      <Footer />
    </>
  );
}
